module.exports = __webpack_public_path__ + "img/przelewy24_logo_2022_grey.48e5b9b0.svg";